module.exports = __webpack_public_path__ + "img/skills-nova-sor-1.f30ff5e6.png";